import { TProps } from './types/TProps';

export const AuthCallout = ({ children }: TProps) => (
  <div className="mb-8 rounded-lg border border-[var(--color-border)] bg-[var(--color-surface-muted)] px-4 py-3 text-sm text-[var(--color-text)]">
    {children}
  </div>
);
